import * as React from "react";
const SvgFiRrDialMin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M10.5 2.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 10.5 2.5M19 13c0 3.86-3.141 7-7 7s-7-3.14-7-7 3.141-7 7-7 7 3.14 7 7m-2 0c0-2.757-2.243-5-5-5s-5 2.243-5 5c0 1.018.306 1.965.83 2.756l3.463-3.463a.999.999 0 1 1 1.414 1.414L9.244 17.17c.791.524 1.738.83 2.756.83 2.757 0 5-2.243 5-5M1.5 11.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 1.5 11.5m21 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 22.5 11.5M4.5 7a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 4.5 7m15 12a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 19.5 19m-15 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 4.5 19m15-12a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 19.5 7"
    />
  </svg>
);
export default SvgFiRrDialMin;
